import * as api from '../apiHelper';
import { arriveNotice } from '../noticeActions';
import {
  setFetchLoaderLoading,
  setFetchLoaderReset,
  setSubmissionLoaderLoading,
  setSubmissionLoaderReset,
} from '../fetchLoaderActions';

async function adminGetManualClaimRequestsApi(params, adminToken, dispatch) {
  const response = await api.get({
    path: 'youtube-cid/manual-claims/admin/requests',
    token: adminToken,
    params,
    version: 'gateway',
    isAdminRoute: true,
    dispatch,
  });
  return response.json();
}

async function adminGetManualClaimRequestApi(requestId, adminToken, dispatch) {
  const response = await api.get({
    path: `youtube-cid/manual-claims/admin/requests/${requestId}`,
    token: adminToken,
    version: 'gateway',
    isAdminRoute: true,
    dispatch,
  });
  return response.json();
}

async function adminPatchManualClaimRequestApi(requestId, body, adminToken, dispatch) {
  const response = await api.patch({
    path: `youtube-cid/manual-claims/admin/requests/${requestId}`,
    token: adminToken,
    body,
    version: 'gateway',
    isAdminRoute: true,
    dispatch,
  });
  return response.json();
}

export function initiateAdminFetchManualClaimRequests(params) {
  return async (dispatch, getState) => {
    const {
      adminAuth: { adminToken },
      fetchLoader: { dataLoading },
    } = getState();

    if (!adminToken) {
      return null;
    }

    if (!dataLoading) {
      dispatch(setFetchLoaderLoading());
    }

    try {
      const data = await adminGetManualClaimRequestsApi(params, adminToken, dispatch);
      return data;
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(arriveNotice(e.message));
      }
      return null;
    } finally {
      dispatch(setFetchLoaderReset());
    }
  };
}

export function initiateAdminFetchManualClaimRequest(requestId) {
  return async (dispatch, getState) => {
    const {
      adminAuth: { adminToken },
      fetchLoader: { dataLoading },
    } = getState();

    if (!adminToken) return null;

    if (!dataLoading) {
      dispatch(setFetchLoaderLoading());
    }

    try {
      const data = await adminGetManualClaimRequestApi(requestId, adminToken, dispatch);
      return data;
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(arriveNotice(e.message));
      }
      return null;
    } finally {
      dispatch(setFetchLoaderReset());
    }
  };
}

export function initiateAdminUpdateManualClaimRequest(requestId, body, options = {}) {
  const { silent = false, quiet = false } = options;
  return async (dispatch, getState) => {
    const {
      adminAuth: { adminToken },
      fetchLoader: { submissionLoading },
    } = getState();

    if (!adminToken) return null;

    if (!quiet && !submissionLoading) {
      dispatch(setSubmissionLoaderLoading());
    }

    try {
      const data = await adminPatchManualClaimRequestApi(requestId, body, adminToken, dispatch);
      if (!silent) {
        dispatch(arriveNotice('Manual claim request updated.', 'ok'));
      }
      return data;
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(arriveNotice(e.message));
      }
      return null;
    } finally {
      if (!quiet) {
        dispatch(setSubmissionLoaderReset());
      }
    }
  };
}
